import { getASOOUsers, getMZOUsers } from "../../../api/nisooApi";
import { AppUserRole } from "../../../models/User";
import { RoleEnum } from "../../../models/User/RoleEnum";

export const isAsooAdministratorsRole = (roleId: RoleEnum | undefined): boolean =>
  roleId === RoleEnum.ASOOAdmin;

export const isMzoAdministratorsRole = (roleId: RoleEnum | undefined): boolean =>
  roleId === RoleEnum.MZOMAdmin ||
  roleId === RoleEnum.MZOM ||
  roleId === RoleEnum.Helpdesk;

export const canFetchAdministrators = (roleId: RoleEnum | undefined): boolean =>
  isAsooAdministratorsRole(roleId) || isMzoAdministratorsRole(roleId);

export async function fetchAdministratorsForRole(
  roleId: RoleEnum | undefined,
): Promise<AppUserRole[]> {
  if (isAsooAdministratorsRole(roleId)) {
    return await getASOOUsers();
  }
  if (isMzoAdministratorsRole(roleId)) {
    return await getMZOUsers();
  }
  return [];
}

